module.exports = __webpack_public_path__ + "img/imagen2.06f73832.png";